import { motion, AnimatePresence } from 'motion/react';
import styles from './Picture.module.css';
import { useEffect, useMemo, useState } from 'react';
import { useMediaLoader } from '../../hooks/useMediaLoader';

export const Picture = ({
  currentMessagesByTag,
  left,
  top,
  width,
  height,
  borderRadius,
}) => {
  const currentMessage = useMemo(() => {
    return currentMessagesByTag?.reduce((prev, current) =>
      Number(prev.timeAdd) > Number(current.timeAdd) ? prev : current,
    );
  }, [currentMessagesByTag]);

  const { url, type } = currentMessage?.message?.attachments[0] || {};
  const { isFullyLoaded } = useMediaLoader(url, type);

  const [currentMedia, setCurrentMedia] = useState({
    currentType: type,
    currentUrl: url,
  });

  useEffect(() => {
    if (isFullyLoaded) {
      setCurrentMedia({
        currentType: type,
        currentUrl: url,
      });
    }
  }, [isFullyLoaded, url]);

  return (
    <motion.div
      initial={{ y: '0rem' }}
      animate={{
        y: [
          '0rem',
          '5.625rem',
          '-0.52rem',
          '5.625rem',
          '-0.52rem',
          '3.33rem',
          '0rem',
        ],
      }}
      transition={{
        times: [0, 0.2, 0.4, 0.6, 0.8, 0.9, 1],
        duration: 40,
        repeat: Infinity,
        ease: ['easeOut', 'easeIn', 'easeOut', 'easeIn', 'easeIn', 'easeIn'],
      }}
      className={styles.pictureBlock}
      style={{ left, top, width, height }}
    >
      <AnimatePresence mode="wait">
        {currentMedia.currentType === 'video' && (
          <motion.video
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            exit={{ opacity: 0 }}
            key={`video-${currentMedia.currentUrl}`}
            autoPlay="autoplay"
            muted="muted"
            loop
            className={styles.media}
            style={{ borderRadius }}
          >
            <source src={currentMedia.currentUrl} type="video/mp4"></source>
          </motion.video>
        )}

        {currentMedia.currentType === 'image' && (
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            exit={{ opacity: 0 }}
            key={`img-${currentMedia.currentUrl}`}
            src={currentMedia.currentUrl}
            alt="Фото"
            className={styles.media}
            style={{ borderRadius }}
          />
        )}

        {/* <motion.div
            className={styles.whiteBg}
            initial={{ opacity: 1, scale: 1 }}
            animate={{ opacity: 0, scale: 5 }}
            transition={{ duration: 2 }}
          /> */}
      </AnimatePresence>
    </motion.div>
  );
};
